﻿import TKModuleFactory from '@tk/utilities/tk.module.factory';
import TKManager from '@tk/basics/tk.manager';
import TKHeader from '@tk/components/tk.header';
import TKNavigationSidebar from '@tk/components/tk.navigation.sidebar';
import TKViewport from '@tk/basics/tk.viewport';
import TKFormValidator from '@/controls/kdmz.form.validator';
import TKFormZipCity from '@tk/controls/tk.form.zipcity';
import TKTabsTab from '@/components/kdmz.tabs.tab';
import TKMinibasket from '@tk/components/tk.minibasket';
import TKTabsAccordion from '@/components/kdmz.tabs.accordion';
import TKCompareListLink from '@tk/components/tk.compare.list.link';
import TKDialog from '@tk/components/tk.dialog';
import KDMZSearch from '@/components/kdmz.search';

// Custom KDMZ elements
import KDMZFormElement from '@/components/kdmz.form.element';

import '@scss/modules/verification.scss';
import '@iconfont/iconfont/material-icons.css';

export default class Verification extends TKModuleFactory {
    constructor() {
        super([
            { name: 'tk-manager', constructor: TKManager },
            { name: 'tk-viewport', constructor: TKViewport },
            { name: 'tk-header', constructor: TKHeader },
            { name: 'tk-nav-sidebar', constructor: TKNavigationSidebar },
            { name: 'tk-search', constructor: KDMZSearch },
            { name: 'tk-form-zip-city', constructor: TKFormZipCity },
            { name: 'tk-form-element', constructor: KDMZFormElement },
            { name: 'tk-form-validator', constructor: TKFormValidator },
            { name: 'tk-tabs-tab', constructor: TKTabsTab },
            { name: 'tk-minibasket', constructor: TKMinibasket },
            { name: 'tk-tabs-accordion', constructor: TKTabsAccordion },
            { name: 'tk-compare-list-link', constructor: TKCompareListLink },
            { name: 'tk-dialog', constructor: TKDialog },
            { name: 'kdmz-search', constructor: KDMZSearch },
        ]);
    }
}

// eslint-disable-next-line no-new
new Verification();
